export const DOCS_URL = 'https://docs.appsvio.com/feature-bundle';
export const CONTACT_US_URL = 'https://get.support.appsvio.com/servicedesk/customer/portal/9/group/19';
export const BROWSE_PROJECTS_PERMISSION = 'BROWSE_PROJECTS';
export const ADMINISTER_PROJECTS_PERMISSION = 'ADMINISTER_PROJECTS';
export const SERVICE_DESK_AGENT_PERMISSION = 'SERVICEDESK_AGENT';
export const GLOBAL_ADMIN__PERMISSION = 'ADMINISTER';
